export const aboutMe = {
	firstParagraph: `Atualmente eu estou focado em aprimorar minhas habilidades como
										Desenvolvedor Front End, e algumas SoftSkills que vão me tornar um
										Desenvolvedor melhor: Comunicação Efetiva, Liderança... Também tenho
										me concentrado no Inglês, estou fazendo o curso na Wise Up.`,
	secondParagraph: `Estou cursando Ciência da Computação na Anhembi Morumbi, e sou
										formado em Técnico em Desenvolvimento de Sistemas pela Etec de Embu.`,
};
